import BOOK_OFFLINE_SKELETON_QUERY from 'graphql/queries/BookOfflineSkeletonQuery.graphql';

/**
 * This function polls the server to check if the offline skeleton for a book is ready,
 * which ensures that the book can be downloaded for offline.
 *
 * @method promiseBookReadyForOffline
 */
const promiseBookReadyForOffline = async (client, epubId) => {
  let backoff = 0;

  do {
    const currentBackoff = backoff;
    await new Promise((resolve) => setTimeout(resolve, currentBackoff));

    const response = await client.query({
      query: BOOK_OFFLINE_SKELETON_QUERY,
      variables: {
        epubId,
      },
      fetchPolicy: 'network-only',
    });

    if (response?.data?.epubByPk?.offlineSkeletonUpdatedAt) {
      return;
    }

    backoff += 2 * 1000;
  } while (true);
};

export default promiseBookReadyForOffline;
